import React from 'react';
import Dropdown from '../../Dropdown/Dropdown';
import DatePicker from 'react-datepicker';
import TextInput from '../../Inputs/TextInput';
import YearPicker from '../../YearPicker/YearPicker';

import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

export default class GeneralStep extends React.Component {
    constructor(props) {
        super(props);

        this.onDatepickerChange = this.onDatepickerChange.bind(this);
        this.updateHours = this.updateHours.bind(this);
        this.isWorkDay = this.isWorkDay.bind(this);
        this.onDealerSelected = this.onDealerSelected.bind(this);
        this.onServiceTypeSelected = this.onServiceTypeSelected.bind(this);

        this.state = {
            hours: [],
            displayHours: '',
            isOtherType: false,
            shouldDisableAppt: false
        };
    }

    componentDidMount() {
        //this.updateHours(this.props.date);
        const datePicker = document.getElementsByClassName("react-datepicker__input-container")[0];
        if(!datePicker) return;
        datePicker.childNodes[0].setAttribute("readOnly", true);
    }

    render() {
        let displayError = Object.keys(this.props.errors).length > 0 ? this.props.errors[Object.keys(this.props.errors)[0]] : '';

        let carMakes = this.getCarMakes();
        let selectedMake = this.props.appointment.make;
        let scheduleTimes = '';
        let carModels = this.getCarModels(selectedMake);

        // opening hours for dealer 
        let selectedCenter = this.props.appointment.center;
        let displayHours = "";
        let relevant = this.props.scheduleTimes.filter(function (item) {
            return item.dealerId == selectedCenter;
        });
        if (relevant.length > 0) {
            displayHours = relevant.map(item => (<p>{item.stringFormat}</p>))
        }
        this.state.displayHours = displayHours;

        // apptSettings
        let shouldDisableApptForToday = false;
        let shouldDisableApptForNext24Hours = false;
        let shouldDisableAppt = false;
        let disabledPhoneNumber = '';
        let disabledPhoneNumberString = '';
        let appointmentMode = 0;
        let domain = '';
        let relevantSettings = this.props.apptSettings.filter(function (item) {
            return item.id == selectedCenter;
        });
        if (relevantSettings.length > 0) {
            shouldDisableApptForToday = relevantSettings[0].shouldDisableApptForToday;
            shouldDisableApptForNext24Hours = relevantSettings[0].shouldDisableApptForNext24Hours;
            shouldDisableAppt = relevantSettings[0].appointmentMode == 1 || relevantSettings[0].appointmentMode == 2;
            appointmentMode = relevantSettings[0].appointmentMode;
            disabledPhoneNumber = relevantSettings[0].phoneNumber;
            disabledPhoneNumberString = relevantSettings[0].phoneNumberString;
            domain = relevantSettings[0].websiteDomain;
        }
        this.state.shouldDisableApptForToday = shouldDisableApptForToday;
        this.state.shouldDisableApptForNext24Hours = shouldDisableApptForNext24Hours;
        this.state.shouldDisableAppt = shouldDisableAppt;
        this.state.date = this.getStateDate();

        //this.setState({ displayHours })
        //

        //let displayHours = this.props.scheduleTimes.map(item => (<p>{item.stringFormat}</p>))
        //this.setState({ displayHours })
        return (
            <div className="generalStep">
                <p className="b-intro">
                    Please select a convenient time to leave your vehicle with us:
                </p>

                <p className={displayError != null && displayError != '' ? "validation-errors" : "validation-errors hidden"} >
                    {displayError}
                </p>

                <Dropdown
                    items={this.props.centers}
                    placeholder="Select a center"
                    name="center"
                    onSelect={this.onDealerSelected}
                    isInvalid={this.props.errors['center']}
                    selectedValue={this.props.appointment.center}
                />

                {shouldDisableAppt && appointmentMode == 1 && <div className="centered-section">
                    <img className="main-icon"
                        src="/images/icon-call.svg"
                    />
                    <h3 className="step-title">
                        <a href={`tel:${disabledPhoneNumber}`}>
                            {disabledPhoneNumberString}
                        </a>
                    </h3>

                    <h4 className="subtitle">
                        Please call us
                        <br />
                        to schedule your appointment
                    </h4>

                    <a className="apply-btn alert-btn"
                        href={`tel:${disabledPhoneNumber}`}>
                        CALL US NOW
                    </a>
                </div>}
                {shouldDisableAppt && appointmentMode == 2 && <div className="centered-section">
                    <h4 className="subtitle">
                        Please click below
                        <br />
                        to schedule your appointment
                        <br/>
                    </h4>

                    <a className="apply-btn alert-btn"
                        href={`${domain}/Appointment-Scheduling`}
                        target="_blank">
                        SCHEDULE APPOINTMENT
                    </a>
                </div>}

                {!shouldDisableAppt &&
                    <p className={this.props.appointment.center != null && this.state.displayHours != '' ? "opening-hours" : "opening-hours hidden"}>
                        <span className="title">Opening Hours: </span>
                        {this.state.displayHours}
                    </p>}
                { !shouldDisableAppt && 
                <DatePicker
                    selected={this.state.date}
                    onChange={this.onDatepickerChange}
                    dateFormat="dddd, MM/DD/YYYY"
                    minDate={this.state.shouldDisableApptForToday ? moment().add('day',1) : moment()}
                    disabled={this.props.appointment.center == null}
                    className="appointment-datepicker form-control"
                    calendarClassName="appointment-calendar"
                    filterDate={this.isWorkDay}
                    popperPlacement="botom-start"
                    popperModifiers={{
                        flip: {
                            enabled: false
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false
                        }
                    }}
                /> }

                { !this.state.shouldDisableAppt && <Dropdown
                    items={this.state.hours}
                    placeholder="Select time"
                    name="hours"
                    disabled={this.props.appointment.center == null}
                    onSelect={this.props.setAppointmentState}
                    isInvalid={this.props.errors['hours']}
                    selectedValue={this.props.appointment.hours}
                /> } 

{ !this.state.shouldDisableAppt && <p className="b-paragraph">
                    Please select service type
                </p>}


                { !this.state.shouldDisableAppt && <div className="form-row">
                    <Dropdown
                        items={this.props.serviceTypes}
                        placeholder="Select service type"
                        name="serviceType"
                        onSelect={this.onServiceTypeSelected}
                        isInvalid={this.props.errors['serviceType']}
                        selectedValue={this.props.appointment.serviceType}
                    />
                </div>}

                { !this.state.shouldDisableAppt && 
                    this.state.isOtherType &&
                    <div className="form-row">
                        <TextInput
                            placeholder="Type here"
                            name="otherServiceType"
                            onChange={this.props.setAppointmentState}
                            value={this.props.appointment.otherServiceType}
                        />
                    </div>
                }


                { !this.state.shouldDisableAppt && <Dropdown
                    items={carMakes}
                    placeholder="Car Make"
                    onSelect={this.props.setAppointmentState}
                    name="make"
                    isInvalid={this.props.errors['make']}
                    selectedValue={this.props.appointment.make}
                />}

                { !this.state.shouldDisableAppt && <div className="form-row">
                    <TextInput
                        placeholder="Car Model"
                        name="carModel"
                        onChange={this.props.setAppointmentState}
                        isInvalid={this.props.errors['name']}
                    />

                    <YearPicker
                        startDate={new Date(1950, 1)}
                        endDate={new Date((new Date().getFullYear()+1),1)}
                        onSelect={this.props.setAppointmentState}
                        selectedValue={this.props.appointment.CarYear}
                        styleClass="half"
                        placeholder="Year"
                        name="CarYear"
                        isInvalid={this.props.errors['carYear']}
                    />
                </div> } 
            </div>
        );
    }

    getStateDate() { 
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isTomorrow = this.props.date.isSame(tomorrow, "day");
        let isToday = this.props.date.isSame(today, "day");
        if(this.state.refreshHours) { 
            this.state.refreshHours = false;
            return this.props.date;
        }
        if(isToday){
            if(this.state.shouldDisableApptForToday || this.state.shouldDisableApptForNext24Hours) { 
                this.props.date = moment().utcOffset(0, true).add(1, 'days');
                this.state.refreshHours = true;
                this.updateHours(this.props.date);
                return this.props.date;
            } else if(!this.state.refreshHours){ 
                // this.props.date = moment().utcOffset(0, true).add(1, 'days');
                this.state.refreshHours = true;
                this.updateHours(this.props.date);
                return this.props.date;
            }
        }
        if(isTomorrow) { 
            let hours = this.getHours(this.props.date);
            if(!hours || hours.length < 1) { 
                this.props.date = moment().utcOffset(0, true).add(2, 'days');
                this.forceUpdate();
            }
        }
        return this.props.date;
    }

    checkSelectedDateForDisabledStates() {
        let selectedCenter = this.props.appointment.center;
        if(!selectedCenter) return;
        // apptSettings
        let shouldDisableApptForToday = false;
        let shouldDisableApptForNext24Hours = false;
        let shouldDisableAppt = false;
        let disabledPhoneNumber = '';
        let disabledPhoneNumberString = '';
        let relevantSettings = this.props.apptSettings.filter(function (item) {
            return item.id == selectedCenter;
        });
        if (relevantSettings.length > 0) {
            shouldDisableApptForToday = relevantSettings[0].shouldDisableApptForToday;
            shouldDisableApptForNext24Hours = relevantSettings[0].shouldDisableApptForNext24Hours;
            shouldDisableAppt = relevantSettings[0].appointmentMode == 1;
        }
        this.state.shouldDisableApptForToday = shouldDisableApptForToday;
        this.state.shouldDisableApptForNext24Hours = shouldDisableApptForNext24Hours;
        this.state.shouldDisableAppt = shouldDisableAppt;
        
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isToday = this.props.date.isSame(today, "day");
        if(isToday) {
            if(shouldDisableApptForToday || shouldDisableApptForNext24Hours){
                this.state.date = this.props.date = this.props.date.add('day',1);

            }
        }
    }

    getCarMakes() {
        if (!this.props.cars) return [];

        return this.props.cars.map((car) => {
            return {
                value: car.makeId,
                label: car.label
            }
        });
    }

    getCarModels(makeId) {
        if (!makeId) return [];

        let selectedCar = this.props.cars.filter((car) => {
            return car.makeId === makeId;
        })[0];

        return selectedCar.models;
    }

    onServiceTypeSelected(e) {
        this.props.setAppointmentState(e);

        let serviceType = this.props.serviceTypes.find(x => x.value === this.props.appointment.serviceType);

        this.setState({ isOtherType: serviceType.label === 'Other' })
    }

    onDealerSelected(e) {
        this.props.setAppointmentState(e);
        this.checkSelectedDateForDisabledStates();
        this.updateHours(this.props.date);
        let selectedCenter = this.props.appointment.center;
        let displayHours = "";
        let relevant = this.props.scheduleTimes.filter(function (item) {
            return item.dealerId == selectedCenter;
        });
        if (relevant.length > 0) {
            displayHours = relevant.map(item => (<p>{item.stringFormat}</p>)); }
        this.setState({ displayHours });
    }

    onDatepickerChange(date) {
        let eventArg = {
            target: {
                name: 'date',
                value: date
            }
        }
        this.props.setAppointmentState(eventArg);
        this.checkSelectedDateForDisabledStates();
        this.updateHours(date);
    }

    isWorkDay(date) {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isToday = date.isSame(today, "day");
        let isTomorrow = date.isSame(tomorrow, "day");
        let dayOfWeek = date.day();
        if((this.state.shouldDisableApptForToday || this.state.shouldDisableApptForNext24Hours) && isToday) {
            return false;
        }
        if(isToday || isTomorrow) {
            let hours = this.getHours(date);
            let isTodayEnabled = hours && hours.length > 0;
            // if(!isTomorrowEnabled) { 
            //     this.props.date = moment().utcOffset(0, true).add(2, 'days');
            // }
            return isTodayEnabled;
        }
        return this.props.scheduleTimes.find(x =>
            x.dealerId === this.props.appointment.center
            &&
            x.startDay <= dayOfWeek
            &&
            x.endDay >= dayOfWeek && x.isClosed !== true);
    }

    getHours(date) {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isTomorrow = date.isSame(tomorrow, "day");
        let isToday = date.isSame(today, "day");
        let hours = [];
        let dayOfWeek = date.day();//new Date(date).getDay();

        let period = this.props.scheduleTimes.find(x =>
            x.dealerId === this.props.appointment.center
            &&
            x.startDay <= dayOfWeek
            &&
            x.endDay >= dayOfWeek && x.isClosed !== true);

        if (period) {
            
            let sTime = period.startTime;
            let eTime = period.endTime;
            if( isToday || 
                (isTomorrow && this.props.shouldDisableApptForNext24Hours)){ 
                // disable time for tomorrow (24 h from now) 
                let hours = new Date().getHours();
                let minutes = new Date().getMinutes();
                if(minutes > 30) { 
                    minutes = '00';
                    hours = hours + 1;
                }
                if(minutes > 0 && minutes < 30) { 
                    minutes = '30';
                }
                sTime = hours + ':' + minutes + ':00';
            }
            hours = this.generateTimePeriod(sTime, eTime)
                .map(x => {
                    return {
                        label: moment.utc(x.asMilliseconds()).format("h:mm A"),
                        value: moment.utc(x.asMilliseconds()).format("HH:mm:ss")
                    };
                });
        }
        return hours;
    }
    updateHours(date) {
        let hours = this.getHours(date);
        this.setState({ hours });
    }

    generateTimePeriod(startTime, endTime) {
        const step = moment.duration(30, 'minutes');
        let period = [];
        let current = moment.duration(startTime);
        let endTimeValue = moment.duration(endTime);

        while (current.asMilliseconds() < endTimeValue.asMilliseconds()) {
            period.push(moment.duration(current));
            current.add(step);
        }
        return period;
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/AppointmentScheduler/AppointmentForm/Steps/GeneralStep.jsx